import { ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { UserType } from 'hooks/useUserData';

export const isQuestionAssignedToMe = ({
  question,
  user,
}: {
  question: ArticleType;
  user: UserType;
}) => {
  return (
    question.createdBy?.toLowerCase() !== user.username?.toLowerCase() &&
    question.targetGroups?.some((group) => user.department?.includes(group)) &&
    question.region?.some((region) => user.region?.includes(region))
  );
};

export const isQuestionAssignedToOthers = ({
  question,
  user,
}: {
  question: ArticleType;
  user: UserType;
}) => {
  return question.createdBy?.toLowerCase() === user?.username?.toLowerCase();
};
